// extracted by css-extract-rspack-plugin
export default {"bui-Container":"j9YF9y0JMsI4PdI6"};